import React from 'react';
import { useNavigate } from 'react-router-dom';
import { canSeeEntry } from '../utils';
import { NAV } from '../navConfig';
import ModuleCard from '../components/ModuleCard';

// Hub for a parent module in NAV: one card per child the user can see.
export default function ModuleHubPage({ user, parentId }) {
  const navigate = useNavigate();
  const parent = NAV.flatMap(g => g.items).find(item => item.id === parentId);
  const modules = parent.children.filter(c => canSeeEntry(user, c));

  return (
    <div className="fade-in">
      <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: '0 0 22px' }}>
        Select a {parent.label} module below.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 18 }}>
        {modules.map(item => (
          <ModuleCard key={item.id} item={item} onOpen={() => navigate(`/${item.id}`)} />
        ))}
      </div>
    </div>
  );
}
